module.exports = __webpack_public_path__ + "static/media/credit_card.fbc002e7.svg";